<template>
    <span>{{ props.value }}</span>
</template>

<script setup lang="ts">
import type { GridComponent } from '@src/Common/Components/types';

const props = withDefaults(defineProps<GridComponent>(), {});
</script>
